<template>
    <div v-show="checkCount()" class="panel panel-primary">
        <div class="panel-heading">
            <div class="panel-title">Подсчет:</div>
        </div>
        <div class="panel-body">
            <div v-for="data_row in data_for_counting">
                <span v-text="data_row.name"></span> -
                <b>
                    <span v-text="countUp(data_row.column_code, data_row.type) + ' ' + data_row.append_to_result || ''"></span>
                </b>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['data', 'data_for_counting'],
    methods: {
        checkCount: function () {
            return this.data.length > 0;
        },
        getMethodName: function (type) {
            return 'apply' + type.charAt(0).toUpperCase() + type.slice(1);
        },
        countUp: function (column_code, type) {
            let method = this.getMethodName(type);
            if (typeof (this[method]) === 'function') {
                return this[method](column_code);
            }

            return null;
        },
        applyTotal: function(column_code) {
            let total = 0;

            for (let i = 0; i < this.data.length; i++) {
                total += Number(this.data[i][column_code]);
            }

            return this.moneyFormat(Math.round(total));
        },
        applyDifferenceTwo: function(column_code) {
            let total = 0;
            let two = column_code.replace(' ','').split(',');

            for (let i = 0; i < this.data.length; i++) {
                total += Number(this.data[i][two[0]]) - Number(this.data[i][two[1]]);
            }

            return this.moneyFormat(Math.round(total));
        },
        applyAverage: function(column_code) {
            let total = 0;
            let quantity = 0;

            for (let i = 0; i < this.data.length; i++) {
                quantity++;
                total += Number(this.data[i][column_code]);
            }

            return Math.round(total / quantity);
        },
        moneyFormat: function (money) {
            return money.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ');
        }
    }
}
</script>
